/**
 * Em que camada a chamada e os controles dela vivem.
 *
 * A tela da chamada é `position: fixed` em 1200, acima de todo o resto do app.
 * Um popover aberto de dentro dela (aparelhos, fundo, volume, aparência) tem de
 * ficar acima DELA — e, junto com o cartão, o scrim que o fecha.
 *
 * Era isso que faltava: o CSS subia só o cartão, o scrim continuava em 60,
 * debaixo da tela da chamada, e o clique de fora batia na chamada em vez de no
 * scrim. Os painéis só fechavam pelo Esc ou clicando no próprio botão.
 */

/** Camada dos popovers abertos de dentro da chamada (o scrim fica em 1299). */
export const CAMADA_DA_CHAMADA = 1300
